export const replaceUndefinedWithNull = (values: Map<string, unknown>) => {
  return Object.fromEntries(Object.entries(values).map(([key, value]) => [key, value === undefined ? null : value]));
};

export const trimAllKey = <T extends Record<string, unknown>>(values: T, trimFields: string[]): T => {
  const result: Record<string, unknown> = {};

  // Iterate over each key in the object
  for (const key in values) {
    if (values.hasOwnProperty(key)) {
      // Check if the current key is in trimFields or if trimFields is empty
      if (trimFields.length === 0 || trimFields.includes(key)) {
        // If the value is a string, trim it
        if (typeof values[key] === "string") {
          result[key] = (values[key] as string).trim();
        } else {
          // If the value is not a string, keep it as is
          result[key] = values[key];
        }
      } else {
        // If the key is not in trimFields, keep the original value
        result[key] = values[key];
      }
    }
  }

  return result as T;
};

// Extract Error RoleId from string
export const parseErrorString = (errorString: string): string[] => {
  // Find the part of the string that contains the IDs
  const match = errorString.match(/\[(.*?)\]/);
  if (!match) {
    throw new Error("Invalid error string format");
  }

  const idPart = match[0]; // Get the matched part including brackets
  // Safely parse the JSON content inside the brackets
  const ids = JSON.parse(idPart) as string[];
  return ids;
};

export const getFilterWithEmptyMasterdata = (master: Array<any>, distinct: string[], keyName: string) => {
  const response = master
    .filter((item) => distinct.includes(item._id))
    .map((item) => {
      return {
        text: item[keyName],
        value: item._id,
      };
    });

  const emptyFilter = [];
  for (const item of distinct) {
    let isFound = false;
    for (const res of response) {
      if (res.value === item) {
        isFound = true;
      }
    }
    if (!isFound) {
      emptyFilter.push(item);
    }
  }
  if (emptyFilter.length > 0)
    response.push({
      text: "",
      value: emptyFilter.join(","),
    });
  return response;
};

export const getQueryParams = (url: string) => {
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  const queryParams: any = {};

  params.forEach((value, key) => {
    queryParams[key] = value;
  });

  return queryParams;
};
